import { NotificationSenderTypeDTO } from '@/entities/notifications/sender/@x/receiver';
import { z } from 'zod/v4';

export const AdminReceiverChannelDTO = z.object({
  sender_name: z.string(),
  sender_type: NotificationSenderTypeDTO,
  sender_active: z.boolean(),
  active: z.boolean(),
  address: z.string(),
  send_resolve: z.boolean(),
});
export type AdminReceiverChannel = z.infer<typeof AdminReceiverChannelDTO>;

/** Адресат в реестре администратора */
export const AdminReceiverDTO = z.object({
  id: z.string(),
  name: z.string(),
  user_id: z.string(),
  user_login: z.string().nullable(),
  active_time_interval_names: z.array(z.string()),
  mute_time_interval_names: z.array(z.string()),
  channels: z.array(AdminReceiverChannelDTO),
  /** Хотя бы один канал попадёт в конфигурацию Alertmanager */
  has_active_channel: z.boolean(),
  subscriptions_count: z.number(),
});
export type AdminReceiver = z.infer<typeof AdminReceiverDTO>;